import React from 'react';

import {
  InvestmentAreasTabPaneDocument,
  useInvestmentAreasTabPaneQuery,
  useDeleteInvestmentAreaMutation
} from 'generated/graphql';
import _ from 'lodash';
import { useLoading } from 'modules';



export interface IInvestmentArea {
  id: string;
  displayName: string;
}

export interface IData {
  investmentAreas: IInvestmentArea[];
}

export function useQuery() {
  const tuple = useInvestmentAreasTabPaneQuery();
  const [deleteInvestmentArea, deleteInvestmentAreaTuple] = __useDeleteInvestmentAreaMutation();
  const loading = useLoading([tuple, deleteInvestmentAreaTuple]);

  const data = React.useMemo((): IData => ({
    investmentAreas: _.map(tuple.data?.investmentAreas, (area): IInvestmentArea => ({
      id: area.id,
      displayName: area.displayName
    }))
  }), [tuple.data?.investmentAreas]);

  return {
    ...tuple,
    data,
    loading,
    mutations: {
      deleteInvestmentArea
    }
  };
}



function __useDeleteInvestmentAreaMutation() {
  const [fnMutate, tuple] = useDeleteInvestmentAreaMutation({
    refetchQueries: [
      InvestmentAreasTabPaneDocument,
      'InvestmentAreasTabPane'
    ]
  });

  async function fnWrappedMutate(id: string) {
    await fnMutate({
      variables: {
        id
      }
    });
  }

  return [fnWrappedMutate, tuple] as const;
}
